// A message spoken to Via instead of typed. The browser records it as one WAV clip in the format below, and the server
// checks a clip is in that format before it goes to the speech service. Neither side keeps the audio.
export const VIA_DICTATION_LIMITS = {
    /** What speech models listen at. A higher rate only makes the upload bigger. */
    sampleRate: 16_000,
    /** The most the speech service takes in one request. */
    maxSeconds: 120,
    /** Less than this is a slip of the finger, not speech. */
    minSeconds: 0.3
};
const HEADER_BYTES = 44;
const BYTES_PER_SAMPLE = 2;
const PCM_FORMAT = 1;
export const VIA_DICTATION_MAX_BYTES = HEADER_BYTES + VIA_DICTATION_LIMITS.maxSeconds * VIA_DICTATION_LIMITS.sampleRate * BYTES_PER_SAMPLE;
/** A mono 16-bit WAV clip at the dictation sample rate, from samples between -1 and 1. */
export const encodeDictationWav = (samples) => {
    const dataBytes = samples.length * BYTES_PER_SAMPLE;
    const bytes = new Uint8Array(HEADER_BYTES + dataBytes);
    const view = new DataView(bytes.buffer);
    const ascii = (offset, text) => {
        for (let index = 0; index < text.length; index++)
            view.setUint8(offset + index, text.charCodeAt(index));
    };
    ascii(0, 'RIFF');
    view.setUint32(4, HEADER_BYTES - 8 + dataBytes, true);
    ascii(8, 'WAVEfmt ');
    view.setUint32(16, 16, true);
    view.setUint16(20, PCM_FORMAT, true);
    view.setUint16(22, 1, true);
    view.setUint32(24, VIA_DICTATION_LIMITS.sampleRate, true);
    view.setUint32(28, VIA_DICTATION_LIMITS.sampleRate * BYTES_PER_SAMPLE, true);
    view.setUint16(32, BYTES_PER_SAMPLE, true);
    view.setUint16(34, BYTES_PER_SAMPLE * 8, true);
    ascii(36, 'data');
    view.setUint32(40, dataBytes, true);
    samples.forEach((sample, index) => {
        const held = Math.max(-1, Math.min(1, sample));
        view.setInt16(HEADER_BYTES + index * BYTES_PER_SAMPLE, Math.round(held * 0x7fff), true);
    });
    return bytes;
};
/** How many seconds of audio a clip written by encodeDictationWav holds, or undefined when the bytes are anything else. */
export const readDictationWavSeconds = (bytes) => {
    if (bytes.length < HEADER_BYTES)
        return undefined;
    const view = new DataView(bytes.buffer, bytes.byteOffset, bytes.byteLength);
    const ascii = (offset, length) => String.fromCharCode(...bytes.subarray(offset, offset + length));
    const isDictationClip = ascii(0, 4) === 'RIFF' &&
        ascii(8, 8) === 'WAVEfmt ' &&
        view.getUint16(20, true) === PCM_FORMAT &&
        view.getUint16(22, true) === 1 &&
        view.getUint32(24, true) === VIA_DICTATION_LIMITS.sampleRate &&
        view.getUint16(34, true) === BYTES_PER_SAMPLE * 8 &&
        ascii(36, 4) === 'data' &&
        view.getUint32(40, true) === bytes.length - HEADER_BYTES;
    if (!isDictationClip)
        return undefined;
    return (bytes.length - HEADER_BYTES) / BYTES_PER_SAMPLE / VIA_DICTATION_LIMITS.sampleRate;
};
//# sourceMappingURL=dictation.js.map